import React, { useEffect, useState } from 'react';

import { Collapse, List, ListItem } from '@material-ui/core';

import IconExpandLess from '@material-ui/icons/ExpandLess';
import IconExpandMore from '@material-ui/icons/ExpandMore';

import { useHistory } from 'react-router-dom';

import NavSection from './NavSection';
import NavMenuItem from './NavMenuItem';

const NavCollapse = (props) => {
  const history = useHistory();

  const { name, icon, iconSize, children, ativo = [] } = props;
  const isExpandable = children && children.length > 0;

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (isUrlInChildren(props, history.location.pathname)) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, []);

  function handleClick() {
    setOpen(!open);
  }

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (isUrlInChildren(props, location.pathname)) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    });

    return () => {
      unlisten(); // remove o listener ao desmontar
    };
  }, []);

  /**
   * Check if the given url can be found
   * in one of the given parent's children
   *
   * @param parent
   * @param url
   * @returns {boolean}
   */
  function isUrlInChildren(parent, url) {
    if (!parent.children) {
      return false;
    }

    for (let i = 0; i < parent.children.length; i++) {
      if (parent.children[i].children) {
        if (isUrlInChildren(parent.children[i], url)) {
          return true;
        }
      }

      if (
        parent.children[i].link === url ||
        url.includes(parent.children[i].link)
      ) {
        return true;
      }
    }

    return false;
  }

  const MenuCollapse = (
    <ListItem
      hidden={!ativo}
      className="nav-collapse-btn"
      button
      onClick={handleClick}
    >
      {/* Display an icon if any */}
      {!!icon && <i className={icon} style={{ fontSize: iconSize }} />}
      <span className="nav-text">{name}</span>
      {/* Display the expand menu if the item has children */}
      {isExpandable && !open && <IconExpandMore className="nav-arrow" />}
      {isExpandable && open && <IconExpandLess className="nav-arrow" />}
    </ListItem>
  );

  const MenuItemChildren = isExpandable ? (
    <Collapse className="nav-collapse-item" in={open} timeout="auto">
      <List component="div" disablePadding>
        {children.map((item, index) => {
          switch (item.type) {
            case 'section':
              return <NavSection {...item} key={index} />;
            case 'collapse':
              return <NavCollapse {...item} key={index} />;
            case 'item':
              return <NavMenuItem {...item} key={index} />;
          }
        })}
      </List>
    </Collapse>
  ) : null;

  return (
    <div className={`nav-collapse ${open ? 'open' : ''}`}>
      {MenuCollapse}
      {MenuItemChildren}
    </div>
  );
};

export default NavCollapse;
